import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AppConfigProvider, ManifestType } from './AppConfigContext';
import i18next from 'i18next';
import { useManifest } from './hooks/useManifest';
import Loading from '../loading/Loading';
import { Maintenance } from '../../Views/errors/maintenance/Maintenance';
import { Offline } from '../../Views/errors/offline/Offline';
import { useOnlineStatus } from '../../Hooks/useOnlineStatus';

type Props = {
	children: React.ReactNode;
};

export default function AppConfig({ children }: Props) {
	const { t } = useTranslation('Common');
	const isOnline = useOnlineStatus();

	const [manifest, setManifest] = useState<ManifestType>({
		name: t('LMS'),
		description: t('A big LMS'),
		background_color: '#ffffff',
		theme_color: '#dd3d31',
		categories: [],
		lang: 'en-US',
	});
	const { data, isLoading, isError, refetch } = useManifest();

	useEffect(() => {
		if (data?.data.name) {
			setManifest(data?.data);
			if (data?.data.lang) {
				const [base] = data.data.lang.split('-');
				i18next.changeLanguage(base);
			}
		}
	}, [data]);

	const handleRetry = useCallback(() => {
		refetch();
	}, [refetch]);

	if (!isOnline || isError) {
		return <Offline onRetry={handleRetry} />;
	}

	if (isLoading) {
		return <Loading />;
	}

	const nodeEnv = import.meta.env.MODE;

	if (manifest.maintenance && nodeEnv !== 'development') {
		return <Maintenance />;
	}

	return (
		<AppConfigProvider value={{ manifest, setManifest }}>
			<div className="AppConfig">{children}</div>
		</AppConfigProvider>
	);
}
